import React, { useState } from "react";
import "../styles/login.css";
import Apis from '../services/apis';

const Resetpassword = () => 
{
  const [step, setStep] = useState(1);
  const apis = new Apis();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [cognitoUser, setCognitoUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // STEP 1 — SEND OTP
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await apis.forgotPassword(email);
      setCognitoUser(res.user);
      setStep(2);
    } catch (err) {
      setError(err.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  // STEP 2 — CONFIRM PASSWORD
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }

    setLoading(true);
    try {
      await apis.confirmForgotPassword(
        cognitoUser,
        otp,
        newPassword
      );
      alert("Password reset successful. Please login.");
      window.location.href = "/login";
    } catch (err) {
      setError(err.message || "Failed to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="xcontainer">
        <div className="branding">
          <img
            src="https://cdn.prod.website-files.com/6704fe9ff2554866b346ff70/6949702df1e902a9654a063a_Pricing%20Culture.JPG"
            alt="Pricing Culture Logo"
            className="logo-img"
            style={{ paddingTop: "10px" }}
          />
        </div>

        <h1 className="title">Reset Password</h1>

        {/* STEP 1 — EMAIL */}
        {step === 1 && (
          <form onSubmit={handleSendOtp}>
            <div className="form-group">
              <input
                type="email"
                className="form-input"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </form>
        )}

        {/* STEP 2 — OTP + PASSWORD */}
        {step === 2 && (
          <form onSubmit={handleResetPassword}>
            <label className="form-label">Enter OTP </label>
            <div className="form-group">
              <input
                type="text"
                className="form-input"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">New password</label>
              <div className="input-wrapper">
                <input
                  type={showNewPassword ? "text" : "password"}
                  className="form-input password-input"
                  placeholder="New password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  👁
                </button>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Confirm new password</label>
              <div className="input-wrapper">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-input password-input"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  👁
                </button>
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <button type="submit" style={{marginTop:20}} className="submit-btn" disabled={loading}>
              {loading ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default Resetpassword;